import React, { useState } from "react"
import DashboardModal      from "./dashboard_modal"

const DashboardDropdown = ({ 
  widgetTemplates = [], 
  dashboards, 
  openDashboard,
  saveDashboard,
  userCanSave,
  currentDashboard,
  setDashboardView
}) => {
  if (!widgetTemplates.length > 0) return

  const [isOpen, setIsOpen] = useState(false)

  const onSave = (selected, name) => {
    saveDashboard(name, selected)
    setIsOpen(false)
    setDashboardView(true)
  }

  return (
    <>
      { dashboards.length > 0 ?
          <span className = "dropdown">
            <button
              data-toggle = "dropdown"
              className = "btn btn-primary small btn-sm mr-2"
            >
              <i className = "fa fa-chart-pie" /> {I18n.t("export.dashboards")}
            </button>
            
            <div className = "dropdown-menu">
              { dashboards.map(dashboard => {
                return (
                  <div 
                    key       = {dashboard.id}
                    className = "dropdown-item"
                    onClick   = {() => openDashboard(dashboard)}
                  >
                    {dashboard.name} {dashboard?.published ? "" : I18n.t("export.not_published")}
                  </div>
                )
              })}

              { userCanSave && 
                <>
                  <hr className = "m-0"/>
                  <div 
                    className = "dropdown-item"
                    onClick   = {() => setIsOpen(true)}
                  >
                    {I18n.t("button.add")}
                  </div>
                </>
              }
            </div>
          </span>
          :
          <button
            className = "btn btn-primary small btn-sm mr-2"
            onClick   = {() => setIsOpen(true)}
          >
            <i className = "fa fa-chart-pie" /> {I18n.t("export.dashboard")}
          </button>
      }

      { userCanSave && 
        <DashboardModal 
          id               = {"new-dashboard-modal"}
          title            = {I18n.t('export.create_new_dashboard')}
          widgetTemplates  = {widgetTemplates}
          isOpen           = {isOpen}
          setIsOpen        = {setIsOpen}
          onConfirm        = {onSave}
          currentDashboard = {currentDashboard}
          confirmText      = {I18n.t("export.save")} 
        />
      }
    </>
  )
}

export default DashboardDropdown